import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import axios from 'src/utils/axios';

const useStyles = makeStyles((theme) => ({
  div: {
    fontWeight: 'bold',
    fontSize: '12px',
    width: '100%'
  }
}));

function DirectionProcess() {
  const classes = useStyles();
  const [expandedConfirm, setExpandedConfirm] = React.useState(false);
  const [selectedDirectionStatus, setSelectedDirectionStatus] =
    React.useState(null);
  const [uyari, setUyari] = React.useState(false);
  const [responseMessage, setresponseMessage] = React.useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  const handleToggleCollapse = () => {
    setExpandedConfirm(!expandedConfirm);
  };

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const directionStatus = [
    { Dsc: 'Satış Onayı', Id: 12 },
    // { Dsc: 'Yedek Parça Onayı', Id: 18 },
    { Dsc: 'KGY Onayı', Id: 22 }
  ];

  function DirectionStatus() {
    const data = {
      //Buraya servis numarası ve başvuru numarası yazılacak!!
      ServiceNumber: invoiceData[0]?.Exchange?.Service?.toString(), //Servis Numarası
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo?.toString() //Başvuru No
    };
    if (selectedDirectionStatus?.Id == 12) {
      axios
        .post('TransferSalesRegion', data, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then((response) => {})
        .catch((err) => {
          setresponseMessage({
            ErrorCode: 0,
            ErrorDescription: err.response.data
          });
          setUyari(true);
          return;
        });
    }
    // if (selectedDirectionStatus?.Id == 18) {
    //   axios.post('TransferSparePart', data, {
    //     headers: { 'Content-Type': 'application/json' }
    //   }).then(response => {
    //   }).catch(err => {
    //     setresponseMessage({
    //       ErrorCode: 0,
    //       ErrorDescription: err.response.data,
    //     });
    //     setUyari(true);
    //     return
    //   });
    // }
    if (selectedDirectionStatus?.Id == 22) {
      axios
        .post('TransferKGY', data, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then((response) => {})
        .catch((err) => {
          setresponseMessage({
            ErrorCode: 0,
            ErrorDescription: err.response.data
          });
          setUyari(true);
          return;
        });
    }
  }
  return (
    <>
      <Grid style={{ paddingTop: 10 }}></Grid>
      <Card
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          backgroundColor: '#f5f5f5',
          boxShadow: 'none'
        }}
      >
        <CardHeader
          sx={{
            backgroundColor: '#f5f5f5',
            borderRadius: '12px',
            padding: '12px 16px',
            '& .MuiCardHeader-title': {
              fontSize: '12px',
              fontWeight: 500
            }
          }}
          avatar={
            <DragIndicatorIcon sx={{ color: '#FF9800', fontSize: '20px' }} />
          }
          action={
            <Tooltip title={expandedConfirm ? 'Daralt' : 'Genişlet'}>
              <IconButton
                onClick={handleToggleCollapse}
                sx={{ color: '#FF9800' }}
              >
                {expandedConfirm ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Tooltip>
          }
          title="Yönlendirme"
        />
        <Collapse in={expandedConfirm} timeout="auto" unmountOnExit>
          <CardContent
            sx={{
              padding: '16px',
              backgroundColor: '#fff',
              borderRadius: '0 0 12px 12px'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Autocomplete
                  id="combo-box-demo"
                  options={directionStatus}
                  getOptionLabel={(i) => i.Dsc}
                  value={selectedDirectionStatus || null}
                  size="small"
                  onChange={(event, val) => {
                    setSelectedDirectionStatus(val);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Yönlendirme Tipi"
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: '12px' }
                      }}
                      InputLabelProps={{
                        style: { fontSize: '11px', color: '#757575' }
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4} md={12}>
                <Button
                  fullWidth
                  size="medium"
                  sx={{
                    color: '#fff',
                    backgroundColor: '#FF9800',
                    borderRadius: '12px',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '13px',
                    '&:hover': {
                      backgroundColor: '#F57C00'
                    }
                  }}
                  onClick={() => DirectionStatus()}
                >
                  Yönlendir
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Collapse>
      </Card>
      <Grid style={{ paddingTop: 20 }}></Grid>
    </>
  );
}

export default DirectionProcess;
